
import Header from "../../header";
import Footer from "../../footer";
import ContactForm from "../../contactcomponents/contactform";
import BannerFooter from "../productpages/bannerForFooter";
import resourceimage from '../../../images/footerLinksImages/featuresimage/resource.jpg'
function ResourceMaterial() {
    const keywords = [
        { title: "Extensive Reading Material", summary: "Access a wide range of reading materials, including books, articles, and research papers to enhance your learning experience." },
        { title: "Video Tutorials", summary: "Watch step-by-step video tutorials created by experts to guide you through complex topics and enhance your understanding." },
        { title: "Practice Exercises", summary: "Engage in practice exercises designed to help you apply concepts and reinforce your learning through hands-on experience." },
        { title: "Case Studies", summary: "Study detailed case studies to understand real-world applications of theories and solve practical problems." },
        { title: "Interactive Learning Modules", summary: "Utilize interactive learning modules that provide an immersive learning experience with quizzes, assignments, and assessments." },
        { title: "Templates and Tools", summary: "Get access to templates, tools, and resources to streamline your learning process and apply your knowledge effectively." },
        { title: "Research Databases", summary: "Explore a variety of research databases with up-to-date information and resources to support your academic and professional growth." },
        { title: "Downloadable Resources", summary: "Download a range of resources, including guides, worksheets, and reference materials to use at your convenience." },
        { title: "Comprehensive Study Guides", summary: "Benefit from detailed study guides that summarize key topics, concepts, and strategies to help you prepare for exams and assessments." },
        { title: "Expert-Led Webinars", summary: "Attend webinars hosted by industry experts who share valuable insights, tips, and best practices for mastering your subject." },
      ];
    return (<>
        <Header />
      
        <BannerFooter
            title="Comprehensive Resources & Materials"
            text="Our programs offer comprehensive resources and materials designed to provide in-depth knowledge in trading, the stock market, and web technologies. Students have access to a wide range of study materials, including market analysis tools, real-time stock data, trading simulators, and web development resources. We provide interactive guides, e-books, and video tutorials that cover everything from basic concepts to advanced strategies. With our resources, learners can practice live trading, explore stock market fundamentals, and enhance their web development skills with the latest technologies, ensuring a hands-on and practical learning experience."
            imageone={resourceimage}
            imagetwo={resourceimage}
        />
        <div className="container-fluid py-5 bg-light">
  <div className="container p-4 shadow-lg bg-white rounded">
    <h2 className="text-center mb-4">Comprehensive Resources & Materials</h2>
    <div className="accordion" id="resourcesAccordion">
      {keywords.map((item, index) => (
        <div className="accordion-item" key={index}>
          <h2 className="accordion-header" id={`heading-${index}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapse-${index}`}
              aria-expanded="false"
              aria-controls={`collapse-${index}`}
              style={{ transition: "all 0.3s ease" }}
            >
              {item.title}
            </button>
          </h2>
          <div
            id={`collapse-${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={`heading-${index}`}
            data-bs-parent="#resourcesAccordion"
          >
            <div className="accordion-body">
              {item.summary}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
        <ContactForm />
        <Footer />
    </>)
}

export default ResourceMaterial